import Address from "./Address";
import UserInfo from "./UserInfo";

class Profile {
  constructor(data) {
    if (data) {
      this.ProfileId = data.ProfileId;
      this.LanguageId = data.LanguageId;
      this.AddressId = data.AddressId;
      this.MarriageStatusId = data.MarriageStatusId;
      this.ReligionId = data.ReligionId;
      this.CasteId = data.CasteId;
      this.CasteLevel2Id = data.CasteLevel2Id;
      this.CasteLevel3Id = data.CasteLevel3Id;
      this.CommunitiesId = data.CommunitiesId;
      this.ProfileHabits = data.ProfileHabits;
      this.ProfileHobbies = data.ProfileHobbies;
      this.Education = data.Education;
      this.CollageName = data.CollageName;
      this.Ocuupation = data.Ocuupation;
      this.Salary = data.Salary;
      this.Height = data.Height;
      this.Weight = data.Weight;
      this.BuildId = data.BuildId;
      this.SkinToneId = data.SkinToneId;
      this.FamilyId = data.FamilyId;
      this.IsPhotoVisible = data.IsPhotoVisible;
      this.RelationId = data.RelationId;
      this.JobRole = data.JobRole;
      this.QualificationId = data.QualificationId;
      this.ProfileDescription =data.ProfileDescription;
      this.address = new Address(data.address);
      this.userInfo = new UserInfo(data.User);
      this.familyDetails = data.familyDetails;
      this.familyWealth = data.familyWealth;
    } else {
      this.LanguageId = null;
      this.AddressId = null;
      this.MarriageStatusId = null;
      this.Ocuupation = null;
      this.JobRole = null;
      this.QualificationId = null;
      this.ReligionId = null;
      this.CasteId = null;
      this.CasteLevel2Id = null;
      this.CasteLevel3Id = null;
      this.CommunitiesId = null;
      this.ProfileHabits = [];
      this.ProfileHobbies = [];
      this.Education = null;
      this.CollageName = null;
      this.OccupationId = null;
      this.Salary = null;
      this.Height = null;
      this.Weight = null;
      this.BuildId = null;
      this.SkinToneId = null;
      this.FamilyId = null;
      this.IsPhotoVisible = false;
      this.RelationId = null;
      this.ProfileDescription = null;
      this.userInfo = new UserInfo();
      this.address = new Address();
      this.familyDetails = [];
      this.familyWealth = [];
    }
  }
}

export default Profile;
